import { StyledTag } from 'components/shared';
import {
  Stack,
  getTheme,
  IconButton,
  IStyle,
  IToggleStyles,
  Toggle,
  IIconProps,
  IStackStyles,
  DocumentCard
} from '@fluentui/react';
import React, { useState } from 'react';
import { SubjectMetadata, trackEvent } from 'services';

const expandIcon: IIconProps = { iconName: 'miniExpand' };
export interface ContentFramesProps {
  metadata: SubjectMetadata;
}

const containerStyle: React.CSSProperties = {
  display: 'block',
  position: 'fixed',
  zIndex: 1002,
  top: 0,
  left: 0,
  background: 'rgba(0, 0, 0, 0.8)',
  marginLeft: 'auto'
};
const frameCardStyle: React.CSSProperties = {
  maxWidth: '90%',
  backgroundColor: 'white',
  borderRadius: 4,
  padding: '10px'
};
const cardStyle: Partial<IStackStyles> = {
  root: {
    borderRadius: 4,
    borderWidth: 0,
    maxWidth: '100%',
    boxShadow: '0px 1.6px 3.6px 0px rgba(0, 0, 0, 0.13), 0px 0.3px 0.9px 0px rgba(0, 0, 0, 0.11)'
  }
};
export interface ZoomFrameModalProps {
  isOpen: boolean;
  image: string;
  onClose: () => void;
}

export const ZoomFrameModal: React.FunctionComponent<ZoomFrameModalProps> = props => {
  return (
    <div
      id="ZoomContainer"
      className="h-100 w-100"
      style={{ ...containerStyle, display: props.isOpen ? 'block' : 'none' }}
      onClick={(event): void => {
        if (event.currentTarget.id === 'ZoomContainer') {
          props.onClose();
        }
      }}
    >
      <Stack className="h-100 w-100" horizontal horizontalAlign="center" verticalAlign="center">
        <Stack.Item align="center" style={frameCardStyle}>
          <img src={props.image} alt={props.image} />
        </Stack.Item>
      </Stack>
    </div>
  );
};

export const ContentFrames: React.FunctionComponent<ContentFramesProps> = props => {
  const [blur, setBlur] = useState<boolean>(true);
  const [isModalOpen, setIsModalOPen] = useState<boolean>(false);
  const [frameName, setFrameName] = useState('');
  const { fonts } = getTheme();
  const textStyle: IStyle = {
    fontFamily: fonts.mediumPlus.fontFamily,
    fontSize: fonts.mediumPlus.fontSize,
    lineHeight: fonts.mediumPlus.lineHeight
  };
  const toggleStyle: Partial<IToggleStyles> = { text: textStyle };
  const blurFilter = { overflow: 'hidden', filter: blur ? 'blur(40px)' : '' };
  const metadata = props.metadata;
  if (!metadata.frames) {
    return <div></div>;
  }

  return (
    <>
      <div className="mb-3">
        <Toggle
          className="p-0 m-0"
          checked={blur}
          onText="Blur images"
          offText="Blur images"
          onChange={(event, checked?: boolean): void => setBlur(!!checked)}
          styles={toggleStyle}
        />
      </div>
      {metadata.frames.map(item => (
        <>
          <DocumentCard styles={cardStyle} className="mb-3">
            <Stack.Item>
              <Stack className="w-100 px-2 pt-2">
                <Stack.Item grow align="start" className="py-1">
                  <StyledTag tag={item.trait} />
                </Stack.Item>
                <div key={item.time} className="position-relative overflow-hidden">
                  {item.image && (
                    <img src={item.image} alt={item.time.toLocaleString()} className="mw-100" style={blurFilter} />
                  )}
                </div>
              </Stack>
            </Stack.Item>
            <Stack.Item>
              <Stack>
                <Stack.Item grow align="end">
                  {item.image && (
                    <IconButton
                      styles={{ icon: { fontSize: fonts.large.fontSize } }}
                      iconProps={expandIcon}
                      title="Expand"
                      ariaLabel="Expand"
                      onClick={() => {
                        setIsModalOPen(true);
                        setFrameName(item.image as string);
                        trackEvent('Expand Frame', {
                          component: 'ContentFrames',
                          eventType: 'click'
                        });
                      }}
                    />
                  )}
                </Stack.Item>
              </Stack>
            </Stack.Item>
          </DocumentCard>
        </>
      ))}
      {isModalOpen && (
        <ZoomFrameModal image={frameName} isOpen={isModalOpen} onClose={(): void => setIsModalOPen(false)} />
      )}
    </>
  );
};
